
import {
  FormValidatedErrorsKey,
  FormValidatedUpdateKey,
  FormValidatedValuesKey,
} from "@/types/inject";
import axios from "axios";
import { computed, defineComponent, inject, ref, watch, Ref } from "vue";

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tclass: String,
    iclass: String,
    msgArrastar: String,
    accept: String,
  },
  emits: ["loadFile"],
  setup(props, { emit }) {
    const values = inject(FormValidatedValuesKey, {});
    const errors = inject(FormValidatedErrorsKey, {});
    const name = computed(() => props.name);

    const onUpdate = inject(FormValidatedUpdateKey);

    const value = computed(() => values[props.name] as string);
    const file: Ref<HTMLInputElement | null> = ref(null);
    const fileName: Ref<string | null> = ref(null);
    const loading = ref(false);

    const onChange = () => {
      loading.value = false;
      fileName.value = null;
      typeof onUpdate === "function" &&
        onUpdate({
          [props.name]: "",
        });
      if (file.value && file.value.files?.length) {
        loading.value = true;
        let reader = new FileReader();
        reader.onloadend = () => {
          const fname =
            (file.value && file.value.files && file.value.files[0].name) ?? "";
          emit("loadFile", reader.result as string);

          typeof onUpdate === "function" &&
            onUpdate({
              [props.name]: reader.result as string,
            });

          fileName.value = fname;
          loading.value = false;
        };
        reader.readAsDataURL(file.value.files[0]);
      }
    };

    const onDragOver = (event: Event) => {
      event.preventDefault();
      const el = event.currentTarget as HTMLElement;
      if (!el.classList.contains("bg-green-300")) {
        el.classList.remove("bg-gray-100");
        el.classList.add("bg-green-300");
      }
    };

    const onDragLeave = (event: Event) => {
      event.preventDefault();
      const el = event.currentTarget as HTMLElement;
      el.classList.add("bg-gray-100");
      el.classList.remove("bg-green-300");
    };

    const onDrop = (event: DragEvent) => {
      event.preventDefault();
      if (file.value && event.dataTransfer && event.dataTransfer.files) {
        file.value.files = event.dataTransfer.files;
        onChange();
      }
      const el = event.currentTarget as HTMLElement;
      el.classList.add("bg-gray-100");
      el.classList.remove("bg-green-300");
    };

    return {
      onChange,
      value,
      fileName,
      file,
      error: computed(() => errors[props.name]),
      onDragOver,
      onDragLeave,
      onDrop,
      loading,
    };
  },
});
